// export default function FloatingWhatsApp() {
//   const phone = "995557141614";
//   const message = encodeURIComponent("გამარჯობა, მაინტერესებს სანტექნიკის სერვისი.");
//   // const messengerUrl = "https://m.me/Tbil.Heating";
//   const messengerUrl = "https://www.facebook.com/messages/t/Tbil.Heating";

//   return (
//     <div className="fixed bottom-5 right-5 z-40 flex flex-col items-end gap-3">
//       <a
//         href={messengerUrl}
//         target="_blank"
//         rel="noreferrer"
//         aria-label="Messenger"
//         title="Messenger"
//         className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-[#1877F2] text-white shadow-[0_12px_28px_rgba(24,119,242,0.42)] transition hover:-translate-y-1 hover:bg-[#1166d6]"
//       >
//         <span className="text-xl font-black leading-none">f</span>
//       </a>

//       <a
//         href={`https://wa.me/${phone}?text=${message}`}
//         target="_blank"
//         rel="noreferrer"
//         aria-label="WhatsApp"
//         title="WhatsApp"
//         className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_14px_34px_rgba(37,211,102,0.45)] transition hover:-translate-y-1 hover:bg-[#21bf5f]"
//       >
//         <span className="text-xl leading-none">💬</span>
//       </a>
//     </div>
//   );
// }

export default function FloatingWhatsApp() {
  const phone = "995557141614";
  const message = encodeURIComponent("გამარჯობა, მაინტერესებს სანტექნიკის სერვისი.");

  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col items-end gap-3">
      {/* Messenger */}
      <a
        href="https://www.messenger.com/t/Tbil.Heating"
        target="_blank"
        rel="noreferrer"
        aria-label="Messenger"
        title="Messenger"
        className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-[#0084FF] text-white shadow-[0_16px_30px_rgba(0,132,255,0.35)] transition hover:scale-105 hover:bg-[#1d92ff]"
      >
        <svg
          viewBox="0 0 24 24"
          className="h-6 w-6 fill-current"
          aria-hidden="true"
        >
          <path d="M12 2C6.48 2 2 6.14 2 11.25c0 2.91 1.46 5.5 3.74 7.2V22l3.33-1.83c.89.24 1.84.37 2.93.37 5.52 0 10-4.14 10-9.25S17.52 2 12 2Zm1.07 12.44-2.54-2.71-4.95 2.71 5.44-5.78 2.56 2.71 4.92-2.71-5.43 5.78Z" />
        </svg>
      </a>

      {/* WhatsApp */}
      <a
        href={`https://wa.me/${phone}?text=${message}`}
        target="_blank"
        rel="noreferrer"
        aria-label="WhatsApp"
        title="WhatsApp"
        className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_14px_34px_rgba(37,211,102,0.45)] transition hover:-translate-y-1 hover:bg-[#21bf5f]"
      >
        <span className="text-xl leading-none">💬</span>
      </a>
    </div>
  );
}
